import { Component, h, Host, Prop } from '@stencil/core'

@Component({
    tag: 'zr-loyalty-points-price-info',
    styleUrl: 'zr-loyalty-points-price-info.scss',
    scoped: true,
})

/**
 * The zooroyal Loyalty Points Info.
 */
export class ZrLoyaltyPointsPriceInfo {
    /**
     * The points which should be displayed.
     */
    @Prop() points?: number;

    /**
     * The Info text for loyalty Points.
     */
    @Prop() info?: string;

    /**
     * The Info Usp Box Head text for loyalty Points.
     */
    @Prop() infoUspBoxHead: string;

    /**
     * The Info Usp Box text for loyalty Points.
     */
    @Prop() infoUspBoxText: string;

    /**
     * The Info Usp Box link for loyalty Points.
     */
    @Prop() infoUspBoxLink: string;

    /**
     * Returns the aria description for the rating icon.
     */
    private loyaltyPointsText() {
        return this.info?.replace('%s', this.points.toLocaleString());
    }

    /**
     * Renders the component.
     */
    render() {
        return (
            <Host>
                <div class="zr-loyalty-points-price-info__wrapper">
                    <div class="zr-loyalty-points-price-info__icon">
                        <a href="/account"><img
                            width={60}
                            height={60}
                            src='/assets/dist/img/detail/zoo_club_logo.svg' alt='dog'/></a>
                    </div>
                    <div class="zr-loyalty-points-price-info__info">{this.loyaltyPointsText()}</div>
                </div>
                <div class="usp-box">
                    <h4>{this.infoUspBoxHead}</h4>
                    <span innerHTML={this.infoUspBoxText} />
                    <div>
                        <a href="/account"> {this.infoUspBoxLink} </a>
                    </div>
                </div>
            </Host>
        )
    }
}
